import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import ModuleLayout from '../common/ModuleLayout';

const { FiBookOpen } = FiIcons;

const ModuleThree = ({ data, onSave, completed }) => {
  const [formData, setFormData] = useState({
    projectScope: 'new',
    targetWordCount: '',
    estimatedChapters: '',
    bookType: 'standalone',
    idealStartDate: '',
    idealFinishDate: '',
    sessionsPerWeek: '',
    wordsPerSession: '',
    preferredDays: []
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (data) setFormData(prev => ({ ...prev, ...data }));
  }, [data]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = async (markComplete) => {
    setIsLoading(true);
    setTimeout(() => {
      onSave(formData, markComplete);
      setIsLoading(false);
    }, 800);
  };

  const canComplete = ['targetWordCount', 'idealStartDate', 'idealFinishDate', 'sessionsPerWeek'].every(f => 
    formData[f] && formData[f].toString().trim() !== ''
  );

  return (
    <ModuleLayout
      title="Build Your Book Plan"
      description="Turn vision into a realistic, grace-filled plan that fits real life."
      icon={FiBookOpen}
      onSave={handleSave}
      completed={completed}
      canComplete={canComplete}
      isLoading={isLoading}
    >
      <div className="space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl shadow-sm p-8 border border-slate-100">
            <label className="block text-sm font-bold text-slate-400 uppercase tracking-wider mb-4">Target Word Count</label>
            <input
              type="number"
              value={formData.targetWordCount}
              onChange={(e) => handleInputChange('targetWordCount', e.target.value)}
              className="w-full p-4 bg-slate-50 border border-slate-100 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all"
              placeholder="e.g., 50000"
            />
          </div>
          <div className="bg-white rounded-2xl shadow-sm p-8 border border-slate-100">
            <label className="block text-sm font-bold text-slate-400 uppercase tracking-wider mb-4">Sessions Per Week</label>
            <input
              type="number"
              value={formData.sessionsPerWeek}
              onChange={(e) => handleInputChange('sessionsPerWeek', e.target.value)}
              className="w-full p-4 bg-slate-50 border border-slate-100 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all"
              placeholder="e.g., 3"
            />
          </div>
          <div className="bg-white rounded-2xl shadow-sm p-8 border border-slate-100">
            <label className="block text-sm font-bold text-slate-400 uppercase tracking-wider mb-4">Start Date</label>
            <input
              type="date"
              value={formData.idealStartDate}
              onChange={(e) => handleInputChange('idealStartDate', e.target.value)}
              className="w-full p-4 bg-slate-50 border border-slate-100 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all"
            />
          </div>
          <div className="bg-white rounded-2xl shadow-sm p-8 border border-slate-100">
            <label className="block text-sm font-bold text-slate-400 uppercase tracking-wider mb-4">Target Finish Date</label>
            <input
              type="date"
              value={formData.idealFinishDate}
              onChange={(e) => handleInputChange('idealFinishDate', e.target.value)}
              className="w-full p-4 bg-slate-50 border border-slate-100 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all"
            />
          </div>
        </div>
      </div>
    </ModuleLayout>
  );
};

export default ModuleThree;